import React from "react";
import { Checkbox, Icon, Label, Table } from "semantic-ui-react";
import { formatCurrency } from "../helpers/currency";
import { mapCustomerStatus } from "../helpers/labels";
import {
  convertSecondsToISOTime,
  getDatePart,
  getTimePart,
} from "../helpers/datetime";

const ComplianceAlertTableRow = ({
  record,
  selectedAlerts,
  onAlertClick,
  handleSelect,
  frsEnabled,
}) => {
  return (
    <Table.Row
      key={record.id}
      className="cursor-pointer"
      onClick={() => onAlertClick(record)}
    >
      <Table.Cell
        textAlign="center"
        onClick={(e) => {
          handleSelect(e, record.id);
        }}
      >
        <Checkbox
          checked={selectedAlerts.includes(record.id)}
          onChange={(event) => {
            handleSelect(event, record.id);
          }}
        />
      </Table.Cell>
      <Table.Cell className="text-sm">
        {getDatePart(record.alertTime)} {getTimePart(record.alertTime)}
      </Table.Cell>
      <Table.Cell className="text-sm">{record.alertType.name}</Table.Cell>
      {frsEnabled && (
        <>
          <Table.Cell className="text-sm" textAlign="center">
            {mapCustomerStatus(record.customer) ?? "-"}
          </Table.Cell>
          <Table.Cell className="text-sm" textAlign="center">
            {record.estimatedAge ?? "-"}
          </Table.Cell>
        </>
      )}
      <Table.Cell>
        <Label className="text-sm" textAlign="center">{record.positionNumber || "-"}</Label>
      </Table.Cell>
      <Table.Cell>
        <Label className="text-sm" textAlign="center">{record.machineInstallationNumber || "-"}</Label>
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {formatCurrency(record.netLoss)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {convertSecondsToISOTime(record.timeOnGame)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        {formatCurrency(record.spend)}
      </Table.Cell>
      <Table.Cell className="text-sm" textAlign="center">
        <Icon
          name={record.active ? "check" : "close"}
          color={record.active ? "green" : "red"}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default ComplianceAlertTableRow;
